module.exports = __webpack_public_path__ + "img/search.63ca9ac8.svg";